const STORAGE_KEYS = {
  CATEGORY: 'scanner_category',
  CHART_PREFIX: 'scanner_chart_',
  PORTFOLIO_ASSET_TYPE: 'scanner_portfolio_asset_type',
};

// Контекст по умолчанию для каждой категории
const CATEGORY_DEFAULTS = {
  crypto_100:  { global: 'USD',   coinDetails: 'USD', chartSlug: 'BTC' },
  crypto_300:  { global: 'USD',   coinDetails: 'USD', chartSlug: 'BTC' },
  top_assets:  { global: 'SP500', coinDetails: 'USD', chartSlug: 'SP500' },
  usa:         { global: 'SP500', coinDetails: 'USD', chartSlug: 'SP500' },
  commodities: { global: 'SP500', coinDetails: 'USD', chartSlug: 'SP500' },
  ru:          { global: 'IMOEX', coinDetails: 'RUB', chartSlug: 'IMOEX' },
  ru_bluechip: { global: 'IMOEX', coinDetails: 'RUB', chartSlug: 'IMOEX' },
  briefcase:   { global: 'USD',   coinDetails: 'USD', chartSlug: 'BTC' },
};

const DEFAULT_FALLBACK = { global: 'USD', coinDetails: 'USD', chartSlug: 'BTC' };

export const categoryStorage = {
  //Сохранить категорию
  setCategory(categorySlug) {
    try {
      localStorage.setItem(STORAGE_KEYS.CATEGORY, categorySlug);
    } catch (error) {
      console.error('Ошибка сохранения категории:', error);
    }
  },

  //Получить категорию из localStorage
  getCategory() {
    try {
      return localStorage.getItem(STORAGE_KEYS.CATEGORY);
    } catch (error) {
      console.error('Ошибка чтения категории:', error);
      return null;
    }
  },

  //Очистить категорию
  clearCategory() {
    try {
      localStorage.removeItem(STORAGE_KEYS.CATEGORY);
    } catch (error) {
      console.error('Ошибка очистки категории:', error);
    }
  },

  //Сохранить саб-фильтр типа актива на Портфеле
  setPortfolioAssetType(assetType) {
    try {
      localStorage.setItem(STORAGE_KEYS.PORTFOLIO_ASSET_TYPE, assetType);
    } catch (error) {
      console.error('Ошибка сохранения фильтра портфеля:', error);
    }
  },

  //Получить сохранённый саб-фильтр типа актива на Портфеле
  getPortfolioAssetType() {
    try {
      return localStorage.getItem(STORAGE_KEYS.PORTFOLIO_ASSET_TYPE);
    } catch (error) {
      console.error('Ошибка чтения фильтра портфеля:', error);
      return null;
    }
  },

  //Получить контекст по умолчанию для категории (global, coinDetails, chartSlug)
  getCategoryDefaults(categorySlug) {
    return CATEGORY_DEFAULTS[categorySlug] || DEFAULT_FALLBACK;
  },

  //Сохранить выбранный график для конкретной категории
  setChartSlug(categorySlug, chartSlug) {
    try {
      localStorage.setItem(STORAGE_KEYS.CHART_PREFIX + categorySlug, chartSlug);
    } catch (error) {
      console.error('Ошибка сохранения графика:', error);
    }
  },

  //Получить сохранённый график для категории (или null)
  getChartSlug(categorySlug) {
    try {
      return localStorage.getItem(STORAGE_KEYS.CHART_PREFIX + categorySlug);
    } catch (error) {
      console.error('Ошибка чтения графика:', error);
      return null;
    }
  },
};
